import Vue from 'vue';
import Vuex from 'vuex';
import user from './user';
import paper from './paper';
import convert from './convert';
import persistedState from "vuex-persistedstate";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    paper,
    convert
  },
  plugins: [persistedState({
    storage: window.sessionStorage   // 默认是 plugins: [createPersistedState()]，对应的是window.localstorage
  })]
});
